import { createContext } from 'react';

export const START_STREAM = 'start_stream';

const SocketContext = createContext();

export default SocketContext;
